import React, { useEffect, useState } from "react";
import { Button, Modal, TextBox, Select, Checkbox, DatePicker, InlineNotification, ConfirmationModal } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const COIViewModal = (props) => {
    //Variables
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [endUserView, setEnduserView] = useState([]);
    const [idChannel, setIdChannel] = useState();
    const [idEndUser, setIdEndUser] = useState();
    const [newUser, setNewUser] = useState(false);
    const [idEndUserNew, setIdEndUserNew] = useState("");
    const [endUserNameNew, setEndUserNameNew] = useState("");
    const [pressIdNew, setPressIdNew] = useState("");
    const [dateCOINew, setDateCOINew] = useState("");
    const [datePrintOs, setDatePrintOs] = useState("");
    const [dateConfirmationCOINew, setDateConfirmationCOINew] = useState("");
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [errorCustomer, setErrorCustomer] = useState(false);
    const [errorUserName, setErrorUserName] = useState(false);
    const [errorPrintOs, setErrorPrintOs] = useState(false);
    const [errorCOI, setErrorCOI] = useState(false);
    const [errorCOIConfirm, setErrorCOIConfirm] = useState(false);
    const [errorPress, setErrorPress] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [confirButton, setConfirButton] = useState(false);
    const [dataEndUser, setDataEndUser] = useState([]);
    //Metodos 
    useEffect(() => {
        if(props.showModal){
            if(props.editValue){
                setIdChannel([props.item.idCustomer]);
                setEnduserView([{value: props.item.idEndUser, label: props.item.enduserName,}])
                setIdEndUser([props.item.idEndUser])
                setPressIdNew(props.item.idPress);
                setDatePrintOs(props.item.datePrintOs);
                setDateCOINew(props.item.dateCOI);
            }
            const datesLoad = (status, data) => {
                const items = data.map((item) => {
                    return { value: moment(item.date).format("YYYY-MM-DD"), };
                });
                const date = items[0] === undefined ? null : items[0].value;
                setDateSelected(date);
            };
            connectApi.get("api/Channels/reports/Dates/", "", datesLoad ).catch((error) => {
                Swal.fire( "Error " + error.response?.status, error.response?.data, "error" );
            });
        }
    },[props.showModal]);
    const fetchEndUsers = (channel) => {
        connectApi.get("api/Channels/endUsers",{
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListData).catch((error) => {
            Swal.fire(
                "Error " + error?.response,
                error?.response,
                "error"
            );
        });
    };
    const EndUserListData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        setEnduserView(items);
    };
    const closeModal = () => {
        props.setEditValue(false);
        setNewUser(false);
        setEnduserView([]);
        setIdChannel(undefined);
        setIdEndUser(undefined);
        setIdEndUserNew("");
        setEndUserNameNew("");
        setPressIdNew("");
        setDateCOINew("");
        setDateConfirmationCOINew("");
        setDataEndUser([]);
        setNotificationDetails({ title: '', type: '', description: '' });
        setShowNotification(false);
        setDatePrintOs("");
        props.setItem({});
        props.setShowModal(false);
    };
    const handlePrintOsDate = (newDate) => {
        setDatePrintOs(newDate);
    };
    const handleCOIDate = (newDate) => {
        setDateCOINew(newDate);
    };
    const handleCOIConfirmationDate = (newDate) => {
        setDateConfirmationCOINew(newDate);
    };
    const setTexbox = (val, num) => {
        if (num == 0)
            setIdEndUserNew(val);
        else if (num == 1)
            setEndUserNameNew(val);
        else if (num == 2)
            setPressIdNew(val);
    }
    const setToggle = (bool) => {
        setNewUser(bool.target.checked);
    }
    const validData = () => {
        let bool = false;
        if(idChannel == undefined){
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("customerName")
            });
            setErrorCustomer(true);
            setShowNotification(true);
        } else if(!newUser && idEndUser == undefined){
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("endUserName")
            });
            setErrorUserName(true);
            setShowNotification(true);
        } else if (newUser && idEndUserNew == "") {
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("endUserId")
            });
            setErrorUserName(true);
            setShowNotification(true);
        } else if (newUser && endUserNameNew == "") {
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("endUserName")
            });
            setErrorUserName(true);
            setShowNotification(true);
        } else if(pressIdNew == ""){
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("pressid")
            });
            setErrorPress(true);
            setShowNotification(true);
        } else if ( datePrintOs == "" ) {
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("canNotLeftEmpty")+t("datePrintOs")
            });
            setErrorPrintOs(true);
            setShowNotification(true);
        } else if ( dateCOINew == "" || new Date(datePrintOs) > new Date(dateCOINew)) {
            if(new Date(datePrintOs) > new Date(dateCOINew)){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("dateInstallCOI")+t("datePrintOs")
                });
            } else {
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("canNotLeftEmpty")+t("dateCOI")
                }); 
            }
            setErrorCOI(true);
            setShowNotification(true);
        } else if (dateConfirmationCOINew == "" || new Date(dateCOINew) > new Date(dateConfirmationCOINew)) {
            if ( new Date(dateCOINew) > new Date(dateConfirmationCOINew) ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("dateConfirmCOI")+t("dateCOI")
                });
            } else {
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("canNotLeftEmpty")+t("confirmationCOI")
                });
            }
            setErrorCOIConfirm(true);
            setShowNotification(true);
        } else if (props.editValue) {
            let item = props.dataCOI.filter((item) => item.idPress == pressIdNew && item.idEndUser.toUpperCase()==idEndUser[0].toUpperCase() && item.idCustomer==idChannel[0] );
            if(item.length > 0){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("pressRepeatedCOI")
                });
                setErrorPress(true);
                setShowNotification(true);
            } else bool = true;
        } else bool = true;

        if (bool && new Date(dateSelected) > new Date(dateConfirmationCOINew)) setConfirButton(true);
        else if (bool) sendDataBackEnd(); 
    }
    const clearError = () => {
        setErrorCustomer(false);
        setErrorUserName(false);
        setErrorPrintOs(false);
        setErrorCOI(false);
        setErrorCOIConfirm(false);
        setErrorPress(false);
    }
    const sendDataBackEnd = () => {
        let data = new FormData();
        data.append("Action", props.editValue?1:0);
        data.append("idPress", pressIdNew);
        data.append("idEndUser", newUser?idEndUserNew:props.editValue?props.item.idEndUser:dataEndUser[0].value);
        data.append("enduserName", newUser?endUserNameNew:props.editValue?props.item.enduserName:dataEndUser[0].label);
        data.append("idCustomer", idChannel);
        data.append("datePrintOs", props.editValue?props.item.datePrintOs:moment(datePrintOs).format("YYYY-MM-DD"));
        data.append("dateCOI", moment(dateCOINew).format("YYYY-MM-DD"));
        data.append("dateCOIConfirm", moment(dateConfirmationCOINew).format("YYYY-MM-DD"));
        data.append("idCOI", props.editValue?props.item.idCOI:0);
        const handleUploadResponse = (status, response) => {
            if (response === 'allGood') {
                setNotificationDetails({
                    title: t('notifyAllCorrect'),
                    type: 'positive',
                    description: ''
                });
            } else {
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setShowNotification(true);
            if (response === 'allGood'){
                setTimeout(() => {
                    props.setReloadPage(!props.reloadPage);
                    props.setOptionVal("0");
                }, 700);
                closeModal();
            }
        }
        connectApi.post(
            "api/Channels/uploadCOIViewAdd",
            data,
            handleUploadResponse
        ).catch((error) => {
            props.setShowModal(false);
            Swal.fire(
                "Error " + error.response?.status,
                error.response?.data, "error"
            );
        });
    }
    //vista
    return (
        <>
        {confirButton? (
            <ConfirmationModal
                id="confirmation-modal" 
                onConfirm={() => {setConfirButton(false); sendDataBackEnd();}}
                onClose={() => setConfirButton(false)}
                show={confirButton}
                title={t("requestConfirmation")}
            >
                <p>{t("notifyDateLastPublicationCOI")}</p>
            </ConfirmationModal>
        ):(
            <Modal
                id="form-modal"
                onClose={() => closeModal()}
                show={props.showModal}
                title="COI"
                footer={(
                <div className="vn-button-group--responsive">
                    {props.editValue?(<Button onClick={() => validData()}>{t('modify')}</Button>):(<Button onClick={() => validData()}>{t('save_button')}</Button>)}
                    <Button appearance="secondary" onClick={() => closeModal()}>{t('cancel')}</Button>
                </div>
                )}
            >
                <div style={{ paddingBottom: 20 }}>
                <Select
                    id="idChannel"
                    options={props.channels}
                    label={t("customerName")}
                    value={idChannel || []}
                    onChange={(val) => {fetchEndUsers(val.value); setIdChannel([val.value]);}}
                    onClear={() => {setIdEndUser(undefined); setEnduserView([]); setIdChannel(undefined);}}
                    readOnly={props.editValue}
                    error={errorCustomer}
                />
                </div>
                <div style={{ paddingBottom: 20 }}>
                <Checkbox id="newUser-modal" label="Usuario nuevo?" checked={newUser} onChange={(val) => setToggle(val)} disabled={props.editValue} />
                </div>
                {newUser?(
                    <div>
                        <div style={{ paddingBottom: 20 }}>
                        <TextBox label={t("endUserId")} id="idUser-modal" value={idEndUserNew} onChange={(value) => { setTexbox(value, 0) }}/>
                        </div>
                        <div style={{ paddingBottom: 20 }}>
                        <TextBox label={t("endUserName")} id="name-modal" value={endUserNameNew} onChange={(value) => { setTexbox(value, 1) }} error={errorUserName}/>
                        </div>
                    </div>
                ):(
                    <div style={{ paddingBottom: 20 }}>
                    <Select
                        id="idEndUser"
                        options={endUserView}
                        label={t("endUserName")}
                        value={idEndUser}
                        onChange={(val) => {setIdEndUser([val.value]);setDataEndUser([val]);}}
                        onClear={()=>setIdEndUser(undefined)}
                        readOnly={props.editValue}
                        error={errorUserName}
                    />
                    </div>
                )}
                <div style={{ paddingBottom: 20 }}>
                    <TextBox label={t('pressid')} id="idUser-modal" readOnly={props.editValue} value={pressIdNew} onChange={(value) => { setTexbox(value, 2) }} error={errorPress} />
                </div>
                <div style={{ paddingBottom: 20 }}>
                <DatePicker
                        format="YYYY-MM-DD"
                        label={t("datePrintOs")}
                        placeholder="YYYY-MM-DD"
                        value={datePrintOs}
                        onChange={handlePrintOsDate}
                        monthYearNavigation
                        calendarOrientation={['up']}
                        error={errorPrintOs}
                        disabled={props.editValue}
                    />
                </div>
                <div style={{ paddingBottom: 20 }}>
                <DatePicker
                        format="YYYY-MM-DD"
                        label={t("dateCOI")}
                        placeholder="YYYY-MM-DD"
                        value={dateCOINew}
                        onChange={handleCOIDate}
                        monthYearNavigation
                        calendarOrientation={['up']}
                        error={errorCOI}
                    />
                </div>
                <div style={{ paddingBottom: 20 }}>
                <DatePicker
                        format="YYYY-MM-DD"
                        label={t("confirmationCOI")}
                        placeholder="YYYY-MM-DD"
                        value={dateConfirmationCOINew}
                        onChange={handleCOIConfirmationDate}
                        monthYearNavigation
                        calendarOrientation={['up']}
                        error={errorCOIConfirm}
                    />
                </div> <br />
                    {showNotification ? (
                        <div className="show-animated" style={{ marginBottom: '-12px' }}>
                            <InlineNotification
                                title={notificationDetails.title}
                                type={notificationDetails.type}
                                description={notificationDetails.description}
                                onClose={() => { setShowNotification(false); clearError(); }}
                            /> <br />
                        </div>
                    ) : undefined}
            </Modal>
        )}
        </>
    );
}

export default COIViewModal;